/* eslint react-hooks/exhaustive-deps: "error" */
import { useState, useEffect } from 'react';

function useRestoreFromBackground(cb: () => void) {
  const [wasOnBackground, setWasOnBackground] = useState(false);

  useEffect(() => {
    function wentToBackground() {
      setWasOnBackground(true);
    }

    window.addEventListener('blur', wentToBackground);
    return () => {
      window.removeEventListener('blur', wentToBackground);
    };
  }, []);

  useEffect(() => {
    function cameFromBackground() {
      if (wasOnBackground) {
        setWasOnBackground(false);
        cb();
      }
    }

    window.addEventListener('focus', cameFromBackground);
    return () => {
      window.removeEventListener('focus', cameFromBackground);
    };
  }, [cb, wasOnBackground]);
}

export default useRestoreFromBackground;
